import { PostLinkPreview } from "src/shared/types/src";


export default function LinkPreviewComponent({ linkPreview } : { linkPreview: PostLinkPreview }) {
    const handleLinkPress = async () => {
        linkPreview?.url && window.open(linkPreview.url, '_blank'); // Open link in a new tab
    }

    return (
        <div  onClick={handleLinkPress} className='mg-t-15 link-preview-wrapper d-flex pd-10 cursor-pointer'>
            {
                linkPreview.image ? 
                <div className="link-preview-image-wrap">
                    {
                        (linkPreview.image.endsWith('.svg')) ?
                        <img src={linkPreview.image} alt="link preview" className="link-preview-image" />: 
                        <img src={linkPreview.image } alt="link preview" className="link-preview-image" />
                    }
                </div> : null
            }
            <div className={`link-preview-details-wrap ${!linkPreview.image ? 'pd-l-0 w-100' : ''}`}>
                <p className="fs-14 fw-semibold text-black mg-b-0">{ linkPreview.title }</p>
                <p className="fs-12 text-gray-300 mg-t-2 mg-b-0">{ linkPreview.description }</p>
            </div>
        </div>
    )
}